import { memo } from 'react';
import type { SamplingTaskCardProps } from './sampling-task-card.types.ts';
import { SamplingTaskCard } from './sampling-task-card.tsx';
import type { SamplingJob } from '../../services/api.types.ts';
import { Label } from '@progress/kendo-react-labels';

export const SamplingPlanningTaskCard = memo(
  function SamplingPlanningTaskCard(props: SamplingTaskCardProps) {
    return (
      <SamplingTaskCard {...props}>
        <Label>Company:</Label>
        <span>{props.data.companyTitle}</span>
        <Label>Job No:</Label>
        <span>SSJ{props.data.id}</span>
        <Label>Job Status:</Label>
        <span>{props.data.statusTitle}</span>
      </SamplingTaskCard>
    );
  },
  (prev, next) => {
    const prevJob = prev.data as unknown as SamplingJob;
    const nextJob = next.data as unknown as SamplingJob;

    return prev.data.id === next.data.id && prev.isOverlay === next.isOverlay && prevJob === nextJob;
  }
);
